
import { Component, Vue } from 'vue-property-decorator'
import { queryChartData } from '@/api/query'
import echart, { ECharts } from 'echarts'

import { drawStationSpendingehart } from '@/charts/station/spending_line'
import { drawSpendingPieChart } from '@/charts/station/spending_pie'

@Component({
  name: 'StationChart'
})
export default class extends Vue {
  private loading = false
  private requestId = 0

  private spendingLineChart: ECharts | null = null
  private spendingLineChartData: any[] = []

  private spendingPieChart: ECharts | null = null
  private spendingPieChartData: any[] = []

  private resizeHandler = () => {
    if (this.spendingLineChart) {
      this.spendingLineChart.resize()
    }
    if (this.spendingPieChart) {
      this.spendingPieChart.resize()
    }
  }

  mounted() {
    this.spendingLineChart = this.createChart(this.$refs.spendingLineChartRef as HTMLDivElement)
    this.spendingPieChart = this.createChart(this.$refs.spendingPieChartRef as HTMLDivElement)
    window.addEventListener('resize', this.resizeHandler)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.spendingLineChart) {
      this.spendingLineChart.dispose()
      this.spendingLineChart = null
    }
    if (this.spendingPieChart) {
      this.spendingPieChart.dispose()
      this.spendingPieChart = null
    }
  }

  public async fetchChartsData(filters: any, id: any) {
    const currentRequestId = ++this.requestId
    this.loading = true
    try {
      const [spendingLineChartData, spendingPieChartData] = await Promise.all([
        queryChartData(`/counts/station/${id}/spending/line`, filters),
        queryChartData(`/counts/station/${id}/spending/pie`, filters)
      ])

      if (currentRequestId !== this.requestId) {
        return
      }

      this.spendingLineChartData = spendingLineChartData || []
      this.spendingPieChartData = spendingPieChartData || []
      this.drawCharts(filters)
    } finally {
      if (currentRequestId === this.requestId) {
        this.loading = false
      }
    }
  }

  private drawCharts(filters: any) {
    drawStationSpendingehart(
      this.spendingLineChart as ECharts,
      this.spendingLineChartData,
      filters
    )
    drawSpendingPieChart(
      this.spendingPieChart as ECharts,
      this.spendingPieChartData,
      filters
    )
  }

  private createChart(element: HTMLDivElement) {
    return echart.getInstanceByDom(element) || echart.init(element)
  }
}
